import { LogLevels } from '../../Enums';

export default class ContributionPeriod {
    id: number = 0;
    name: string = "";
    logLevel: LogLevels = LogLevels.Information;
}